// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCompletedSign_root__mKH-d","text":"PlasmicCompletedSign_text__BO1g+"};